'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobileAppRequest = exports.createQueryString = exports.jsonp = exports.superagentToObservable = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _rxjs = require('rxjs');

var _superagentJsonp = require('superagent-jsonp');

var _superagentJsonp2 = _interopRequireDefault(_superagentJsonp);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var superagentToObservable = exports.superagentToObservable = function superagentToObservable(request) {
  var abortOnUnsubscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return _rxjs.Observable.create(function (observer) {
    request.end(function (err, response) {
      if (err) {
        observer.error(err);
      }
      if (response) {
        observer.next(response);
        observer.complete();
      }
    });

    if (abortOnUnsubscribe) {
      return function () {
        return request.abort();
      };
    }

    return null;
  });
};

/**
 * Makes a JSONP request and returns an observable
 * @param {string} url - url for the JSONP request (must end with callback=)
 * @return {Observable}
 */
var jsonp = exports.jsonp = function jsonp(url) {
  return superagentToObservable(_superagent2.default.get(url).use((0, _superagentJsonp2.default)({ timeout: 10000 })), false);
};

var createQueryString = exports.createQueryString = function createQueryString(obj) {
  return _lodash2.default.map(obj, function (value, key) {
    return key + '=' + encodeURIComponent(value);
  }).join('&');
};

var MOBILE_APP_NAME = 'BiblioApp';

/**
 * Returns true if the request is from the mobile app.
 *
 * @param {object} request headers
 * @return {boolean}
 */
var isMobileAppRequest = exports.isMobileAppRequest = function isMobileAppRequest() {
  var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var possibleValues = [headers['x-requested-with'], headers['user-agent']];

  var valuesContainingAppName = possibleValues.filter(function (value) {
    return (value || '').indexOf(MOBILE_APP_NAME) !== -1;
  });

  return valuesContainingAppName.length > 0;
};

exports.default = {
  superagentToObservable: superagentToObservable,
  jsonp: jsonp,
  createQueryString: createQueryString,
  isMobileAppRequest: isMobileAppRequest
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-http/lib/index.js
// module id = 373
// module chunks = 1